import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import 'alertifyjs//build/alertify.min.js';
import 'alertifyjs/build/css/alertify.min.css';
import 'alertifyjs/build/css/themes/default.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap-css-only/css/bootstrap.min.css';
import 'mdbreact/dist/css/mdb.css';
import { Provider } from 'react-redux';
import history from './history';
import store from './store'
import { BrowserRouter} from "react-router-dom";
import {loadConsults,silentLogin,getCursosSocio} from './actionCreators';


/*    
var bPreguntar = true;
window.onbeforeunload = preguntarAntesDeSalir;
function preguntarAntesDeSalir()
{
  if (bPreguntar)
    return "¿Seguro que quieres salir?";
}
*/





/*
var getdata = localStorage.getItem("datauser");

if(getdata === null){
  history.push({ pathname: "/" })
}else{

}
*/



ReactDOM.render(
  <Provider store={store}>
      <BrowserRouter >
            <App />
      </BrowserRouter>
  </Provider>,
 
 document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
